import type { MultiStepFormStep } from '#/components/Form/MultiStepForm/MultiStepFormTypes';

export function getAllFieldNamesFromSteps(
  steps: MultiStepFormStep[],
): Set<string> {
  return new Set(
    steps
      .flatMap((step) => step.sections)
      .flatMap((section) => section.rows)
      .filter(Boolean)
      .flatMap((row) => row.fields.concat(row.fieldsToValidate ?? [])),
  );
}
